import { render, staticRenderFns } from "./c_home_tab.vue?vue&type=template&id=13fcb04a&scoped=true"
import script from "./c_home_tab.vue?vue&type=script&lang=js"
export * from "./c_home_tab.vue?vue&type=script&lang=js"
import style0 from "./c_home_tab.vue?vue&type=style&index=0&id=13fcb04a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fcb04a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13fcb04a')) {
      api.createRecord('13fcb04a', component.options)
    } else {
      api.reload('13fcb04a', component.options)
    }
    module.hot.accept("./c_home_tab.vue?vue&type=template&id=13fcb04a&scoped=true", function () {
      api.rerender('13fcb04a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_home_tab.vue"
export default component.exports